import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { makeRequest } from '../../api/api';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { toast } from 'react-toastify';

import SuccessToastMessage from '../../@common/SuccessToast/SuccessToast';
import { customToast } from '../../constant/constant';

export const getAssignmentDetails = createAsyncThunk(
  'assignmentActivity/getAssignmentDetails',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_ASSIGNMENT_STATUS,
          wstoken: thunkApi.getState().auth.token
        }
      );

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const submitAssigmentData = createAsyncThunk(
  'assignmentActivity/submitAssigmentData',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param?.data,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.SAVE_ASSIGNMENT_FILES,
          wstoken: thunkApi.getState().auth.token
        }
      );

      if (param?.toggle) {
        thunkApi.dispatch(
          submitDraftAssignment({ assignmentid: param?.data?.assignmentid })
        );
      } else {
        if (
          response.status == 200 &&
          !(response?.data?.errorcode || response?.data?.exception)
        ) {
          customToast(
            'Success',
            'Your assignment has been submitted successfully.',
            'success',
            5000,
          )
        } else {
          customToast(
            'Error',
            'Something went wrong!!',
            'error',
            5000,
          )
        }
        thunkApi.dispatch(
          getAssignmentDetails({ assignid: param?.data?.assignmentid })
        );
      }
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const submitDraftAssignment = createAsyncThunk(
  'assignmentActivity/submitDraftAssignment',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          acceptsubmissionstatement: 1,
          wsfunction: MOODLE_BACKEND_ROUTES.SAVE_DRAFT_ASSIGNMENT,
          wstoken: thunkApi.getState().auth.token
        }
      );

      if (
        response.status == 200 &&
        !(response?.data?.errorcode || response?.data?.exception)
      ) {
        customToast(
          'Success',
          'Your assignment has been submitted successfully.',
          'success',
          5000,
        )
      } else {
        customToast(
          'Error',
          'Something went wrong!!',
          'error',
          5000,
        )
      }
      thunkApi.dispatch(
        getAssignmentDetails({ assignid: param?.assignmentid })
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const assignmentActivity = createSlice({
  name: 'assignmentActivity',
  initialState: {
    assignmentStatus: {
      isLoading: false,
      activityData: {},
      error: ''
    },
    submitAssigmentData: {
      isLoading: false,
      assignmentSubmitted: false,
      error: ''
    },
    submissionStatus: null,
    gradingStatus: null,
    isDraftSubmissionLoading: false
  },
  reducers: {
    setActivityData: (state, action) => {
      Object.keys(action.payload).map((val) => {
        state[val] = action.payload[val];
      });
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAssignmentDetails.pending, (state) => {
      state.assignmentStatus.isLoading = true;
      state.assignmentStatus.activityData = {};
    });
    builder.addCase(getAssignmentDetails.fulfilled, (state, action) => {
      state.assignmentStatus.isLoading = false;
      state.assignmentStatus.activityData = action?.payload || {};
    });
    builder.addCase(getAssignmentDetails.rejected, (state) => {
      state.assignmentStatus.isLoading = false;
      state.assignmentStatus.activityData = {};
    });
    ///////////////////////////////////////////////////////////////////////////////
    builder.addCase(submitAssigmentData.pending, (state) => {
      state.submitAssigmentData.isLoading = true;
    });
    builder.addCase(submitAssigmentData.fulfilled, (state, action) => {
      state.submitAssigmentData.isLoading = false;
      state.submitAssigmentData.assignmentSubmitted = true;
    });
    builder.addCase(submitAssigmentData.rejected, (state) => {
      state.submitAssigmentData.isLoading = false;
    });
    ///////////////////////////////////////////////////////////////////////////////
    builder.addCase(submitDraftAssignment.pending, (state) => {
      state.isDraftSubmissionLoading = true;
    });
    builder.addCase(submitDraftAssignment.fulfilled, (state, action) => {
      state.isDraftSubmissionLoading = false;
    });
    builder.addCase(submitDraftAssignment.rejected, (state) => {
      state.isDraftSubmissionLoading = false;
    });
  }
});

export const { setActivityData } = assignmentActivity.actions;

export default assignmentActivity.reducer;
